/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_PaidInputs */

const en_status_paid = /** @type {(inputs: Status_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const es_status_paid = /** @type {(inputs: Status_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagado`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Status_PaidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_paid = /** @type {((inputs?: Status_PaidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_PaidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_paid(inputs)
	return es_status_paid(inputs)
});